import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxPlano from "./_components/BoxPlano";

const Planograms = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxPlano />
    </ContentWrapper>
  </>
);

export default Planograms;
